<template>
    <div class="Admin_Dashboard__user_question__list">
                <div class="Admin_Dashboard__user_question__card">
                    <div class="Admin_Dashboard__user_question__card_title">
                        <h2>실시간 질문 목록</h2>
                        <div class="Admin_Dashboard__user_question__select">
                            <!-- <v-select
                                :items="items"
                                placeholder="조회할 강사를 선택하세요."
                                dense
                                outlined
                                color="D8D8D8"
                                class="speaker-select"
                            ></v-select> -->

                            <div class="CourseLive_Session">
                                <v-card class="select" outlined @click="selectbox">
                                    <span v-if="selectedSession === 0 || selectedSession === null" class="selected">
                                        <v-card elevation="0" class="list">
                                            <p class="number">All Session</p>
                                        </v-card>
                                    </span>
                                    <span v-else class="selected">
                                        <v-card elevation="0" class="list">
                                            <p class="number">Session {{ selectedSession }}.</p>
                                        </v-card>
                                    </span>
                                    <span>
                                        <v-icon class="mdi mdi-chevron-down ml-1"></v-icon>
                                    </span>
                                </v-card>
                                <div class="selectlist">
                                    <ul class="listbox" id="listbox" v-show="isListboxVisible">
                                        <div class="session">
                                            <div class="label">
                                                <label>세션 선택</label>
                                            </div>
                                            <!-- <v-card elevation="0" class="list">
                                                <p class="number">All Session</p>
                                            </v-card> -->
                                            <li v-for="(session, index) in sessions" :key="index">
                                                <v-card elevation="0" class="list" :class="{ active: activeSession === index }" @click="sessionselect(index)">
                                                    <!-- <p class="number">Session {{ index + 1 }}.</p> -->
                                                     <p class="number">{{ session }}</p>
                                                </v-card>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                    
                    <!-- <v-btn @click="addCard" color="primary" class="mb-4">카드 추가 TEST</v-btn> -->
                    <transition-group name="slide-x" tag="div">
                        <v-card
                            v-for="(item) in filteredQnaList"
                            :key="item.id"
                            class="Admin_Dashboard__user_question__card_list"
                            transition="slide-x-transition"
                            elevation="0"
                        >
                            <div class="user">
                                <div class="user_info">
                                    <h3>{{ item.Username }}</h3>
                                    <!-- <div><span>{{ item.organization }}</span></div> -->
                                </div>
                            </div>
                            <div class="lecturer">
                                <div class="lecturer_txt">
                                    <h3>{{ item.Speaker }}</h3>
                                    <span class="seminar">{{ item.Seminar }}</span>
                                    <div class="question"><span>{{ item.Question_content }}</span></div>
                                </div>
                            <div class="time">
                                <v-icon class="mdi mdi-clock-outline mr-1" small/><span>{{ item.PostedTime }}</span>
                            </div>
                            </div>
                        </v-card>
                    </transition-group>
                </div>
            </div>
</template>

<script>
export default {
    props: {
        qnaList: {
            type: Array,
            required: true,
        },
    },
data() {
    return {
        items: [
            { id: 1, name: '배지은', organization: '한국지질동맹경화학회', lecturer: '@최연정 강사', question: '질문 드립니다. 스트리밍 중 중단 현상이 발생합니다. 어서 조치해주세여 ~ 췤~~~연정쥐임쓰~!~!질문 드립니다. 스트리밍 중 중단 현상이 발생합니다. 어서 조치해주세여 ~ 췤~~~연정쥐임쓰~!~!질문 드립니다. 스트리밍 중 중단 현상이 발생합니다. 어서 조치해주세여 ~ 췤~~~연정쥐임쓰~!~!질문 드립니다. 스트리밍 중 중단 현상이 발생합니다. 어서 조치해주세여 ~ 췤~~~연정쥐임쓰~!~!', time: '오후 5:37:04' },
            { id: 2, name: '조현재', organization: '한국정보기술협회', lecturer: '@최연정 강사', question: '왜 안되나요? 짜잉나게', time: '오후 5:37:40' },
        ],
        selectedSession: null,
        isListboxVisible: false,
        activeSession: null,
        sessions: ["All Session" ,"Session 1", "Session 2", "Session 3", "Session 4 ", "Session 5", "Session 6"],
    };
},
computed: {
    filteredQnaList() {
        if (this.selectedSession === 0 || this.selectedSession === null) {
                return this.qnaList;
        } else {
            // console.log("this.selectedSession  => ", this.selectedSession )
            const datas = this.qnaList.filter(item => {
                return (
                    item.session_id === this.selectedSession
                );
            });
            return datas;
        }
    },
},
methods: {
    addCard() {
        const newCard = {
            id: this.items.length + 1,
            name: `새 카드 ${this.items.length + 1}`,
            organization: '새로운 조직',
            lecturer: '@김영수 강사',
            question: '새로운 질문이 있습니다.',
            time: new Date().toLocaleTimeString(),
        };
        this.items.push(newCard);
    },
    sessionselect(index) {
        this.selectedSession = index;
        this.activeSession = index;
        this.isListboxVisible = false;
    },
    // 리스트 박스 토글 함수
    selectbox() {
        this.isListboxVisible = !this.isListboxVisible;
    }
}
};
</script>
<style scoped>
.Admin_Dashboard__user_question__card_title .speaker-select{ border: 1px solid #D8D8D8 ;border-radius: 10px !important;height: 40px !important; width: 400px; background: #ffffff;  }
@media screen and (max-width: 680px) {
    .Admin_Dashboard__user_question__card_title { display: block; }
    .Admin_Dashboard__user_question__card_title .speaker-select { width: 100%; margin-top: 8px; }
}

</style>